<template>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn text @click="()=>{this.$router.go(-1)}"><v-icon dark>mdi-arrow-left</v-icon></v-btn>
        <h1>VGAPI Configurator</h1>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="loaders.form"
            style="margin-left: 10px;"
        ></v-progress-circular>
        <v-btn class="ml-2" small color="success" :loading="loaders.saveAll" :disabled="loaders.form" @click="saveAll">Save All</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form :disabled="loaders.form" v-if="data.globals.vgapiConfiguration?.shareList">
          <h3>VGAPI ENABLED</h3>
          <v-checkbox label="Enabled" v-model="data.globals.vgapiConfiguration.enabled"/>
          <v-text-field disabled outlined label="PublicShareKey" v-model="data.globals.vgapiConfiguration.publicShareKey"/>
          <v-text-field outlined label="Public Name" v-model="data.globals.vgapiConfiguration.publicName"/>
          <v-btn @click="regeneratePublicShareKey" color="error">Regenerate Key</v-btn>
          <v-btn @click="setVGCToPL" color="error">Set All VGC To PL</v-btn>
          <hr>
          <span class="d-flex flex-row align-center my-2">
            <h3>Share Nodes</h3>
            <v-btn fab color="info" x-small class="ml-2" @click="addShareListItem"><v-icon>mdi-plus</v-icon></v-btn>
          </span>
          <v-row>
            <v-col lg="6">
              <span v-for="(field, f) of data.globals.vgapiConfiguration.shareList" :key="f">
                <v-card outlined class="d-flex flex-column mt-2">
                  <v-card-text>
                    <div class="d-flex flex-row flex-wrap align-center mb-3" style="gap: 0 4px;">
                      <v-text-field outlined dense hide-details label="Description" v-model="field.description"/>
                      <v-text-field outlined dense hide-details label="API Endpoint" v-model="field.apiEndpoint"/>
                    </div>
                    <v-text-field class="mb-3" outlined dense hide-details label="Key" v-model="field.privateShareKey"/>
                    <v-autocomplete
                      :items="getAllowedBranches"
                      item-text="name"
                      item-value="id"
                      v-model="field.allowedLocations"
                      label="Allowed Locations"
                      outlined
                      chips
                      deletable-chips
                      clearable
                      @click:clear="clearAllowedLocations(f)"
                      multiple
                    />
                    <span>
                      <v-btn color="error" small @click="removeOptionalField(f)">Delete</v-btn>
                      <v-btn color="warning" small @click="findAndSyncProducts(field)">Sync Matched Products</v-btn>
                    </span>
                  </v-card-text>
                </v-card>
              </span>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>


    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import utils from "../../plugins/helpers"

export default {
  name: 'Home',
  data () {
    return {
      utils: utils,

      snackObj: {
        state: false,
        color: '',
        text: ''
      },

      isEditable: false,
      isCreate: true,

      requiredRules: [
        v => !!v || 'Field is required.'
      ],

      requiredBool: true,

      data: {
        globals: {}
      },
      validForm: false,

      loaders: {
        form: false,
        saveAll: false
      },

      taxTypes: [],

      addAttributeDialog: {
        isOpen: false,
        field: null,
        data: {
          name: ""
        }
      },
      restrictedAttributes: ['label', 'v-model'],

      headers: [
        { text: 'ID', align: 'start', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Hidden', value: 'hidden' },
        { text: 'Transactions', value: 'numTransactions' }
      ],

      inputTypeDialog: {
        isOpen: false,
        field: null
      },
    }
  },
  computed: {
    ...mapGetters(['getEndpoint', 'getAllowedBranches'])
  },
  async mounted(){
    try {
      await this.fetchData();

    } catch (error) {
      console.error(error)
      this.snack(error.msg || error.msg?.message || error, "error");
    }
  },
  methods: {
    async fetchData(){
      try{
        this.loaders.form = true;

        let res = await axios.get(`${this.getEndpoint}/api/vgapiConfigurator`)
        if(res.data.error) throw res.data.error
        this.data = res.data.data

        console.log(this.data)
      }
      catch (e) {
        console.error(e)
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loaders.form = false;
      }
    },
    async saveAll(){
      try{
        this.loaders.form = true;

        console.log("saving", this.data)

        for(let key of Object.keys(this.data.globals)){
          if(typeof this.data.globals[key]!=='boolean' && !Array.isArray(this.data.globals[key])){
            if(this.data.globals[key]===null || this.data.globals[key]===undefined || this.data.globals[key].length===0){
              throw `Value ${key} cannot be empty`;
            }
          }
        }

        let res = await axios.put(`${this.getEndpoint}/api/vgapiConfigurator/saveAll`, {data: this.data})
        if(res.data.error) throw res.data.error

        this.snack(`All saved!`, "success");

        await this.fetchData();
      }
      catch (e) {
        console.error(e)
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loaders.form = false;
      }
    },
    async regeneratePublicShareKey(){
      try{
        this.loaders.form = true;

        let res = await axios.get(`${this.getEndpoint}/api/vgapiConfigurator/regeneratePublicShareKey`)
        if(res.data.error) throw res.data.error

        await this.fetchData()
      }
      catch (e) {
        console.error(e)
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loaders.form = false;
      }
    },
    async setVGCToPL(){
      try{
        this.loaders.form = true;

        let res = await axios.get(`${this.getEndpoint}/api/vgapiConfigurator/setVGCToPL`)
        if(res.data.error) throw res.data.error

        await this.fetchData()
      }
      catch (e) {
        console.error(e)
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loaders.form = false;
      }
    },
    async findAndSyncProducts(obj){
      try{

        this.loaders.form = true;

        let res = await axios.post(`${this.getEndpoint}/api/vgapiConfigurator/findAndSyncProducts`, {obj})
        if(res.data.error) throw res.data.error

        await this.fetchData()
      }
      catch (e) {
        console.error(e)
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loaders.form = false;
      }
    },
    clearAllowedLocations(i){
      this.data.globals.vgapiConfiguration.shareList[i].allowedLocations = []
      this.$forceUpdate()
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.state = true;
      this.snackObj.color = color;
    },
    addShareListItem(){
      if(!this.data.globals){
        this.data.globals = {};
      }
      if(!this.data.globals.vgapiConfiguration){
        this.data.globals.vgapiConfiguration = {};
      }
      if(!this.data.globals.vgapiConfiguration.shareList){
        this.data.globals.vgapiConfiguration.shareList = [];
      }

      this.data.globals.vgapiConfiguration.shareList.push({
        privateShareKey: '',
        allowedLocations: []
      });

      this.$forceUpdate();
    },
    removeOptionalField(i){
      this.data.globals.vgapiConfiguration?.shareList?.splice(i, 1);
      this.$forceUpdate();
    },
    openAddAttributeDialog(field){
      this.addAttributeDialog.isOpen = true;
      this.addAttributeDialog.field = field;
    },
    closeAddAttributeDialog(){
      this.addAttributeDialog.isOpen = false;
      this.addAttributeDialog.data = {name: ""};
      this.addAttributeDialog.field = null;
    },
    addAttribute(){
      if(!this.addAttributeDialog.field) throw "No field to add attribute to."
      if(!this.addAttributeDialog.data.name?.trim()) throw "No name for attribute"
      if(!this.addAttributeDialog.field.attributes){
        this.addAttributeDialog.field.attributes = {};
      }

      if(Object.hasOwn(this.addAttributeDialog.field.attributes, this.addAttributeDialog.data.name.toLowerCase())) throw "This attribute already exists for this field."

      if(this.restrictedAttributes.includes(this.addAttributeDialog.data.name.toLowerCase())) throw "This attribute is not allowed. "

      this.addAttributeDialog.field.attributes[this.addAttributeDialog.data.name.toLowerCase()] = {value: '', route: ''};

      this.closeAddAttributeDialog();

      this.snack('Attribute added')
    },
    deleteAttribute(filter, attr){
      delete filter.attributes[attr];
      this.$forceUpdate();
    },
    closeInputTypeDialog(){
      this.inputTypeDialog.isOpen = false;
      this.inputTypeDialog.field = null;
    },
    openInputTypeDialog(field){
      this.inputTypeDialog.field = field;
      this.inputTypeDialog.isOpen = true;
    },
    setInputType(type){
      this.inputTypeDialog.field.type = type;
      this.inputTypeDialog.isOpen = false;
      this.$forceUpdate()
    },
  }
}
</script>
